import React from "react";
import { ColorProps, SpaceProps, TypographyProps } from "styled-system";
import { Box } from "../Box";

interface Props {
  dangerouslySetInnerHTML?: {
    __html: string;
  };
}

export const Text: React.FC<
  Props & ColorProps & TypographyProps & SpaceProps
> = ({ dangerouslySetInnerHTML, children, ...props }) => (
  <Box as="p" {...props} dangerouslySetInnerHTML={dangerouslySetInnerHTML}>
    {children}
  </Box>
);
